import type { LayoutSizeProps, LayoutSizeCSS } from '../types/layout.types.js';

/**
 * Returns the layout size properties.
 * @internal
 */
export const useLayoutSizeProps = (props: LayoutSizeProps): LayoutSizeCSS => {
  const { width, minWidth, maxWidth, height, minHeight, maxHeight } = props;

  return {
    width,
    minWidth,
    maxWidth,
    height,
    minHeight,
    maxHeight,
  };
};
